import { navigateToCookiePolicy, navigateToPrivacyPolicy } from "@/components/TermsAndPolicyDialog/utils";
import { selectConsent, setConsent } from "@/store/slices/cookieConsentSlice";
import { Box, Link, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import type React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

type ConsentValue = "all" | "deny";

/** Settings panel for managing cookie consent preferences (accept all / deny). */
export const CookiePreferences = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const consent = useSelector(selectConsent);

  const handleConsentChange = (_: React.MouseEvent<HTMLElement>, value: ConsentValue | null) => {
    if (value === null) {
      return;
    }
    dispatch(setConsent(value));
  };

  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        width: "552px",
        minHeight: "min(40vh, 617px)",
        maxWidth: "100%"
      }}
    >
      <Box
        component="div"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "24px"
        }}
      >
        <Box component="div" sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <Typography variant="body1">{t("title.cookiePolicy")}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t(consent === "deny" ? "message.cookiePreferencesDenied" : "message.cookiePreferencesAllowed")}
          </Typography>
        </Box>
        <ToggleButtonGroup value={consent} exclusive onChange={handleConsentChange} size="small" sx={{ flexShrink: 0 }}>
          <ToggleButton value="deny">{t("button.deny")}</ToggleButton>
          <ToggleButton value="all">{t("button.acceptAll")}</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box component="div" sx={{ display: "flex", gap: "16px" }}>
        <Link component="button" variant="body2" onClick={navigateToCookiePolicy}>
          {t("title.cookiePolicy")}
        </Link>
        <Link component="button" variant="body2" onClick={navigateToPrivacyPolicy}>
          {t("title.privacyPolicy")}
        </Link>
      </Box>
    </Box>
  );
};
